import { Component, OnInit } from '@angular/core';
import { BizzboxService } from './bizzbox.service';
import { Router } from '@angular/router';


export interface Subscription {
  id:number;
  first_subscription_day:string;
  first_subscription_expire_day:string;
  product_code:string;
  name: string;
  subscription_day: string;
  expire_day:string;
  price: string;
  renewal_date: string;
  vat: string;
  cycle: string;
  type: string;
  can_renew:boolean;
  btn_message:string;
  purchased:boolean;
  status:string;
}

@Component({
  selector: 'app-bizzbox',
  templateUrl: './bizzbox.component.html',
  styleUrls: ['./bizzbox.component.scss']
})
export class BizzboxComponent implements OnInit{

  constructor(private bizzbox: BizzboxService, private router: Router){}

    subscriptions: Subscription[] = [];


    async ngOnInit() {
    const apps = await this.bizzbox.get_bizzboxes();
    this.subscriptions = await Promise.all(apps);
    console.log(this.subscriptions)

  }


  downloadInvoice(item: Subscription): void {
    // TODO: Implement invoice download
    console.log('Download invoice for:', item);
  }

  renewSubscription(item: Subscription): void {
    // TODO: Implement subscription renewal
    console.log('Renew subscription for:', item);
  }

  buyApp(item: Subscription): void {
    if(item.purchased){
      this.router.navigate(['/main/bizzcalc']);

    }
    else{
      console.log('Buy app for:', item);
    }
  }
}
